import { fileNameOf } from "./dom";
import { store } from "./store";
import { getRunKind, runJavaScript } from "./runner";
import { showHtmlPreview, showReviewPanel } from "./review-panel";

export function initTopBar() {
  const menuBtn = document.getElementById("open-explorer")!;
  const saveBtn = document.getElementById("save-file") as HTMLButtonElement;
  const runBtn = document.getElementById("run-file") as HTMLButtonElement;
  const titleEl = document.getElementById("top-bar-title")!;
  const dirtyDot = document.getElementById("top-bar-dirty-dot")!;

  menuBtn.addEventListener("click", () => store.getState().setExplorerOpen(true));
  saveBtn.addEventListener("click", () => store.getState().saveActiveFile());

  runBtn.addEventListener("click", async () => {
    const { activePath, openFiles } = store.getState();
    const activeFile = openFiles.find((f) => f.path === activePath);
    if (!activeFile) return;

    const kind = getRunKind(activeFile.path);
    if (kind === "html") {
      showHtmlPreview(activeFile.content);
      return;
    }
    if (kind === "js") {
      runBtn.disabled = true;
      try {
        const result = await runJavaScript(activeFile.content);
        showReviewPanel(result.lines, result.timedOut);
      } finally {
        runBtn.disabled = false;
      }
    }
  });

  const render = () => {
    const { activePath, openFiles } = store.getState();
    const activeFile = openFiles.find((f) => f.path === activePath);

    titleEl.textContent = activePath ? fileNameOf(activePath) : "PocketCode";
    dirtyDot.classList.toggle("hidden", !activeFile?.dirty);
    saveBtn.disabled = !activeFile?.dirty;
    runBtn.style.display = activePath && getRunKind(activePath) ? "inline-flex" : "none";
  };

  store.subscribe(render);
  render();
}
